// import React, { useEffect } from "react";
// import {Suspense } from "react";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import Toast from "./utils/Toast";
// import "./utils/language";
// import authRoutes from "./routes/authRoute";
// import dashboardRoutes from "./routes/dashboardRoutes";
// import { useDispatch, useSelector } from "react-redux";
// import { removeAppError } from "./store/userSlice";

// const router = createBrowserRouter([...authRoutes, ...dashboardRoutes]);

// function App() {
//   const { appErrors } = useSelector((state) => state.user);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     for (let i = 0; i < appErrors.length; i++) {
//       setTimeout(() => {
//         dispatch(removeAppError(appErrors[i].id));
//       }, 4000);
//     }
//   }, [appErrors]);
//   useEffect(() => {
//     document.addEventListener("wheel", function (event) {
//       if (document.activeElement.type === "number") {
//         document.activeElement.blur();
//       }
//     });
//   }, []);
//   return (
//       <Suspense fallback={null}>
//         <RouterProvider router={router} />
//         <div className="fixed max-w-sm w-full top-3 left-1/2 transform -translate-x-1/2 sm:right-5 sm:left-auto sm:transform-none">
//           {appErrors.map(({ msg, id, color }, i) => (
//             <Toast key={id} msg={msg} id={id} color={color} />
//           ))}
//         </div>
//       </Suspense>
//   );
// }

// export default App;

import React, { useEffect } from "react";
import { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom"; // THIS IS ENOUGH
import Toast from "./utils/Toast";
import "./utils/language";
import authRoutes from "./routes/authRoute";
import dashboardRoutes from "./routes/dashboardRoutes";
import { useDispatch, useSelector } from "react-redux";
import { removeAppError } from "./store/userSlice";

const router = createBrowserRouter([...authRoutes, ...dashboardRoutes]); // Already Browser based!

function App() {
  const { appErrors } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    for (let i = 0; i < appErrors.length; i++) {
      setTimeout(() => {
        dispatch(removeAppError(appErrors[i].id));
      }, 4000);
    }
  }, [appErrors]);

  useEffect(() => {
    document.addEventListener("wheel", function (event) {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    });
  }, []);

  return (
    <Suspense fallback={null}>
      <RouterProvider router={router} /> {/* THIS IS CORRECT */}
      <div className="fixed max-w-sm w-full top-3 left-1/2 transform -translate-x-1/2 sm:right-5 sm:left-auto sm:transform-none">
        {appErrors.map(({ msg, id, color }, i) => (
          <Toast key={id} msg={msg} id={id} color={color} />
        ))}
      </div>
    </Suspense>
  );
}

export default App;
